export default "__VITE_ASSET__$DdBY86P__"